import { MainLayout } from "./MainLayout";

export const withMainLayout = <P extends object>(
  Component: React.ComponentType<P>
) => {
  const WrappedComponent = (props: P) => (
    <MainLayout>
      <Component {...props} />
    </MainLayout>
  );

  WrappedComponent.displayName = `withMainLayout(${Component.displayName || Component.name || "Component"})`;

  return WrappedComponent;
};
